module.exports = __webpack_public_path__ + "img/img (19).3845f4b9.png";